import { createElement } from 'react';
import './text-description-detail-list-item.scss';
const TextDescriptionDetailListItem = ({ label, value, labelPosition, onClick, children, }) => {
    return (createElement("div", { className: `text-description-detail-list-item position-${labelPosition}`, onClick: onClick },
        labelPosition !== 'none' && createElement("span", { className: "item-label" }, label),
        createElement("span", { className: "item-value" }, value)));
};
TextDescriptionDetailListItem.displayName = 'TextDescriptionDetailListItem';
export default TextDescriptionDetailListItem;
